<template>
  <div>
    <PageHeader title="Products" />
    <ProductPlatformUploadButtonList
      :selected-products="selectedProducts"
      @upload="uploadProducts"
      @remove="removeProducts"
    />
    <ProductListMenuFilters
      :available-filters="availableFilters"
      :selected-filters="selectedFilters"
      :current-page="currentPage"
      @updateKeywordSearch="updateKeywordSearch"
      @updateFilterSearch="updateFilterSearch"
    />
    <ProductListContent class="mt-5" :products="index" @newSelectedRows="newSelectedRows" />
    <Pagination
      :current-page="currentPage"
      :total-count="totalCount"
      :total-pages="totalPages"
      @changePage="handleChangePage"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { PageHeader, Pagination } from "@estaly/ui";
import ProductListContent from "@/views/store/products/list/content/ProductListContent.vue";
import ProductListMenuFilters from "@/views/store/products/list/menu/filters/ProductListMenuFilters.vue";
import ProductPlatformUploadButtonList from "@/views/store/products/list/menu/platform/ProductPlatformUploadButtonList.vue";

export default {
  components: {
    PageHeader,
    ProductPlatformUploadButtonList,
    ProductListMenuFilters,
    ProductListContent,
    Pagination,
  },
  data: () => {
    return {
      currentPage: 1,
      selectedProducts: [],
      availableFilters: {
        productType: [],
        contractStatus: [],
        enabled: [],
      },
      selectedFilters: {
        productType: [],
        contractStatus: [],
        enabled: [],
      },
      keywords: null,
      allProductsSelected: false,
    };
  },

  watch: {
    async selectedStoreId(newSelectedStoreId) {
      if (newSelectedStoreId) await this.retrieveProducts(this.currentPage);
    },
  },

  async beforeMount() {
    await this.retrieveProducts(this.currentPage);
  },

  computed: {
    ...mapState("auth", ["signedIn"]),
    ...mapState("store", ["selectedStoreId"]),
    ...mapState("products", ["index", "totalCount", "totalPages"]),
    ...mapGetters("products", ["getContractStatuses"]),

    selectedProductIds() {
      return this.selectedProducts.map((product) => product.id);
    },

    productParams() {
      return {
        storeId: this.selectedStoreId,
        online: true,
        page: this.currentPage,
        keywords: this.keywords,
        ...this.selectedFilters,
      };
    },
  },
  methods: {
    ...mapActions("notifications", ["notify"]),
    ...mapActions("products", ["fetchIndex", "enableProducts", "disableProducts"]),
    ...mapActions("store", ["withLoader"]),

    async retrieveProducts(page = this.currentPage) {
      this.currentPage = page;
      await this.withLoader(async () => {
        const response = await this.fetchIndex(this.productParams);
        if (response?.filters) this.setAvailableFilters(response.filters);
      });
    },

    setAvailableFilters(filters) {
      this.availableFilters.productType = filters.productTypes;
      this.availableFilters.contractStatus = this.getContractStatuses();
      this.availableFilters.enabled = [true, false];
    },

    handleChangePage(page) {
      this.retrieveProducts(page);
    },

    updateKeywordSearch(keywords) {
      this.keywords = keywords;
      this.retrieveProducts(1);
    },

    updateFilterSearch(filterName, filterOptions) {
      this.selectedFilters[filterName] = filterOptions;
      this.retrieveProducts(1);
    },

    newSelectedRows(selectedProducts) {
      this.selectedProducts = selectedProducts;
    },

    async uploadProducts() {
      const response = await this.enableProducts({ productIds: this.selectedProductIds });
      if (!response?.success) return;
      await this.notify({
        category: "simple",
        type: "success",
        title: "Les offres d’assurance liées aux produits mis à jour sont désormais activées sur votre site.",
      });
      await this.retrieveProducts();
    },

    async removeProducts() {
      const response = await this.disableProducts({ productIds: this.selectedProductIds });
      if (!response?.success) return;
      await this.notify({
        category: "simple",
        type: "success",
        title: "Les offres d’assurance liées aux produits mis à jour sont désormais désactivées sur votre site.",
      });
      await this.retrieveProducts();
    },
  },
};
</script>
